import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewManageUserAuthsComponent } from './view-manage-user-auths.component';

const routes: Routes = [{ path: '', component: ViewManageUserAuthsComponent }, {
  path: '**',
  redirectTo: '',
  pathMatch: 'full'
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ViewManageUserAuthsRoutingModule {
}
